









































































































































































import { orderInfo } from '@/api/daolv'
import { HOTEL_INFO, RES_ORDER_INFO } from '@/api/daolv-api'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'HotelSure'
})
export default class HotelSure extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  orderId!: string

  /**
   * @param {Boolean} isOnRequest 确认
   * @description: true '2个小时内确认'  false '立即确认'
   */
  @Prop({
    type: Boolean,
    default: false
  })
  isOnRequest!: boolean

  private loading = true
  private reserveInfo = {} as RES_ORDER_INFO // 预订信息
  private orderInfo = {} as HOTEL_INFO // 酒店信息
  private roomTypeTable:any[] = [] // 房型信息表格
  private contactTable:any[] = [] // 联系人表格
  private getNight = 0 // 共x晚
  private readonly weekList = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

  get hotelInfoTable () { // 酒店表格
    const { checkInDate, checkOutDate, numOfRooms, priceList } = this.reserveInfo
    return [
      {
        date: checkInDate + '~' + checkOutDate, // 入离信息
        priceList,
        numOfRooms
      }
    ]
  }

  // 获取房型信息表格
  getRoomTypeTable () {
    const arr:any = []
    const { guestList, bedTypeDesc, breakfastTypeDesc } = this.reserveInfo
    console.log(guestList)
    for (let i = 0; i < guestList.length; i++) {
      const guestNameArr:any[] = [] // 名字
      const peopleArr:any = [] // 人数
      for (let j = 0; j < guestList[i].guestInfo.length; j++) {
        guestNameArr.push(guestList[i].guestInfo.map(it => it.name)[j].last + ' ' + guestList[i].guestInfo.map(it => it.name)[j].first)
        peopleArr.push(guestList[i].guestInfo[j])
      }
      arr.push(
        {
          roomNum: '房间' + guestList[i].roomNum,
          bedTypeDesc,
          breakfastTypeDesc,
          guestInfo: peopleArr,
          name: guestNameArr.join('，')
        }
      )
      console.log(peopleArr)
    }
    this.roomTypeTable = arr
    console.log(this.roomTypeTable)
  }

  // 获取联系人表格
  getContactTable () {
    const { email, name, phone } = this.reserveInfo.contact
    this.contactTable = [
      {
        email,
        // 后端取的名字不一定有值（可能为null）
        name: (name.last ? name.last : '') +
        ' ' +
        (name.first ? name.first : ''),
        phone
      }
    ]
  }

  mounted (): void {
    // 提交订单后弹窗 查看订单信息
    orderInfo(this.orderId).then(res => {
      this.loading = false
      if (res.success) {
        this.reserveInfo = res
        this.orderInfo = res.hotelInfo
        this.getNight = this.reserveInfo.priceList.length
        this.getRoomTypeTable()
        this.getContactTable()
      } else {
        this.$message.error(res.msg)
      }
    }).catch(err => {
      console.error(err)
    })
  }
}
